import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'fury-updatetva',
  templateUrl: './updatetva.component.html',
  styleUrls: ['./updatetva.component.scss']
})
export class UpdatetvaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
